import { useSiteData } from 'dumi';
export var useAtomAssets = function useAtomAssets() {
  var _useSiteData = useSiteData(),
      components = _useSiteData.components;

  return {
    components: components
  };
};